<template>

    <div class="news_index" style="background-color: #c53f3e;">
        <router-view>优惠券</router-view>
        <div class="shop_top"><shop-top :subnav_show="false" :change_color="true"></shop-top></div>
        <!-- <div class="mbx width_center_1200">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a href="/news/" style="cursor: pointer;">优惠券</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->

 
<div class="banner1"></div>
<div class="banner2"></div>
<div class="reduction-bottom">


<!--抢领券-->
<div class="vouchers3" v-if="couponsList.length > 0">
	
<div class="content">
<div class="title">
<!-- <span class="textl">暂无活动！</span>-->
<span class="textl">10点准时开抢！</span> 
<span class="textr">
<count-down v-on:start_callback="countDownS_cb(1)" v-on:end_callback="countDownE_cb(1)" currentTime="" :startTime="1594780771" :endTime="1594780818" :tipText="'距离下一场开始剩'" :tipTextEnd="'距离本轮结束还剩'" :endText="'本场已结束'" :dayTxt="'天'" :hourTxt="'小时'" :minutesTxt="'分钟'" :secondsTxt="'秒'"></count-down>
    </span>
</div>
	<div class="vochers_quan" id="vouchers2" style="/*width:750px;*/">
		

		
		
	</div>
</div>
</div>
<!--抢领券-->

    
<div  class="biaoti" v-if="list.length > 0"><img src="/pc/vouchers/v1.png"></div>
<div class="vochers_quan" v-if="list.length > 0">
<div class="quan" v-for="v in list" :key="v.id" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.2)">
<div class="none_quan" v-if="v.total=='0'"></div>
  <div class="quanl">
    <div class="line1">
      <div class="mony" v-if="v.discountid == '6'"><span>折</span>{{parseFloat(Number(10-v.discount*10).toFixed(2))}}</div>
      <div class="mony" v-else><span>￥</span>{{v.discount}}</div>
      <div class="leixing">
        <div class="text" v-if="v.discountid == '6'">满折券</div>
         <div class="text" v-else>满减券</div>
        </div>
    </div>
    <div class="line2">
      <div class="text">订单满{{v.minfee}}使用</div></div>
    <div class="line3">
      <div class="text">（不与其他优惠券叠加）</div>
      <div class="text">使用期限：{{v.usebegin | formatCreateTime}} - {{v.useend | formatCreateTime}} </div></div>
  </div>
   <div class="quanr" v-if="v.total <= '0'">
    <div class="text">已领完</div>
  </div> 
  <div class="quanr" v-else> 
    <div class="text" @click="getCoupon(v.id, index)">立即领取</div>
  </div>

</div>
	</div>

        <div class="empty_order" v-else>
            <dl>
                <p style="color:#fff; text-align:center"><img src="/pc/not-common2-icon.png" alt=""></p>
                <p style="color:#fff; text-align:center; margin-top:30px;">暂无优惠券~</p>
                <p style="color:#fff; text-align:center; margin-top:30px;"><router-link to="/"><el-button type="primary">前往商城</el-button></router-link></p>
            </dl>
        </div>

      <!--全场券-->
<div class="height50"></div>

	</div>


 



        <ShopMbar></ShopMbar>
        <shop-foot></shop-foot>
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"
import CountDown from 'vue2-countdown'
import {formatDate} from '@/utils/date';
  const defaultListQuery = {
    pageNum: 1,
    pageSize: 5,
  };
export default {
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar,
        CountDown
    },
    data() {
      return {
          listQuery: Object.assign({}, defaultListQuery),
          list:[],
          couponsList: [],
          total_data:0, // 总条数
          page_size:30,
          current_page:1,
          loading: false,
      };
    },
    filters:{
      formatCreateTime(time) {
        let date = new Date(time);
        if(time===undefined||time===null||time===''){
          return '暂无';
        }else{
          return formatDate(date, 'yyyy-MM-dd');
        }
      },
      formatCreateTimes(time) {
        let date = new Date(time);
        if(time===undefined||time===null||time===''){
          return '暂无';
        }else{
          return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
        }
      },
    },
    watch: {},
    computed: {},
    methods: {
        //倒计时
        // countDownS_cb: function (x) {
        //     console.log(x)
        // },
        // countDownE_cb: function (x) {
        //     console.log(x)
        // },

        handleSizeChange(val) {
            this.listQuery.pageNum = 1;
            this.listQuery.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.pageNum = val;
            this.getList();
        },
        // getCoupon: function(id, index) {
        //   let that = this;
        //   let list = that.couponsList;
        //   // getCouponReceive(id)
        //   this.$get(this.$api.apparatus_list)
        //     .then(function() {
        //       list[index].is_use = true;
        //       that.$dialog.toast({ mes: "领取成功" });
        //     })
        //     .catch(function(res) {
        //       that.$dialog.toast({ mes: res.message });
        //     });
        // },
        // getUseCoupons: function() {
        //   let that = this;
        //   if (that.loading) return; //阻止下次请求（false可以进行请求）；
        //   if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
        //   that.loading = true;
        //   let q = { page: that.page, limit: that.limit };
        //   // getCoupon(q)
        //   this.$get(this.$api.apparatus_list)
        //   .then(res => {
        //     that.loading = false;
        //     //apply();js将一个数组插入另一个数组;
        //     that.couponsList.push.apply(that.couponsList, res.data.list);
        //     that.loadend = res.data.list.length < that.limit; //判断所有数据是否加载完成；
        //     that.page = that.page + 1;
        //   });
        // },
        //优惠券列表
        getEffectivePromotions_list:function(){
            this.$get(this.$api.getEffectivePromotions,{platId: this.$platId}).then(res=>{
              if(res.code == 200){
                this.list = res.data;
              }else{
                this.$message.error(res.message);
                return this.$router.push('/');
              }
            });
        },
        //领券结果
        receiveResults(){
            this.$get(this.$api.receiveResults,{platId: this.$platId}).then(res=>{
                if(res.code == 200){
                  this.$message.success(res.message);
                  this.getEffectivePromotions_list();
                  this.get_user_info();
                }else{
                  this.$message.error(res.message);
                  this.getEffectivePromotions_list();
                  this.get_user_info();
                }
            });
        },
        getCoupon:function(id) {
            this.$post(this.$api.receiveCouponById+id).then(res=>{
                  this.loading = true;
                if(res.code == 200){
                  this.$message.success(res.message); 
                  setTimeout(() => {
                  this.loading = false;
                  this.receiveResults();
                  }, 1000);
                }else{
                  this.$message.error(res.message); 
                }
            });
        },

        get_user_info:function(){
            this.$get(this.$api.homeGetUserInfo,{platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    this.isLogin = true;
                    this.userInfo = res.data;
                    this.userInfo.isLogin = true;
                    this.userInfo.nowTime =  Date.parse(new Date()) / 1000;
                    localStorage.setItem('userInfo',JSON.stringify(this.userInfo));
                    if(res.data.themeId != ''){
                        localStorage.setItem('themeId',res.data.themeId);
                    }
                    //折扣率
                    if(res.data.company && res.data.rate){
                        if(res.data.rate != '-1'){
                            localStorage.setItem('discount_rate',res.data.rate);
                        }else{
                            localStorage.setItem('discount_rate','');
                        }
                    }else{
                        this.getDiscountRate();
                    }
                }else if(res.code == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('userInfo');        //用户信息
                    localStorage.removeItem('goodsCategory');   //栏目分类
                    localStorage.removeItem('column_list');     //底部菜单
                    localStorage.removeItem('popup_num');       //弹窗广告
                    localStorage.removeItem('serviceInfo');     //清除专属客服专属业务员
                    localStorage.removeItem('token');           //清除token
                    localStorage.removeItem('discount_rate');   //清除折扣率
                    this.isLogin = false;
                }else{
                    this.isLogin = false;
                }

            });
        },

         //获取折扣率
        getDiscountRate:function(){
            this.$get(this.$api.getDiscountRate,{platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    if(res.data && res.data.length > 0){
                        this.discount_rate = res.data[0].rate;
                        localStorage.setItem('discount_rate',JSON.stringify(res.data[0].rate));
                        // console.log(this.discount_rate);
                        // console.log(res.data[0].minfee);
                                            }
                }

            });
        },


            },
    created() {
        //this.getCoupon();
        this.getEffectivePromotions_list();
        
    },
    // mounted() {
    //     this.getUseCoupons();
    //     this.$scroll(this.$refs.container, () => {
    //       !this.loading && this.getUseCoupons();
    //     });
    // },
};
</script>
<style>

body,ul,div,li,img,span{ padding:0; margin:0;}
li{ list-style:none;}
.reduction-top{ background:url(/pc/vouchers/banner.jpg) no-repeat center; height:600px;}
.banner1{ background:url(/pc/vouchers/banner1.jpg) no-repeat center; height:400px;}
.banner2{ background:url(/pc/vouchers/banner2.jpg) no-repeat center; height:400px;}
.reduction-cou{ height:190px;}
.reduction-bottom{  width:100%; overflow:hidden;}
.special-zone{ width:1200px; margin:auto;overflow:hidden; padding-top:30px; padding-bottom:190px; font-family:"黑体";}
.top-good{ width:223px; background-color:#fff; padding-left:5px; padding-bottom:25px; float:left; margin-right:12px; margin-top:20px; box-shadow:0 0 5px #ebebeb;}
.top-good .good-attr{ position:relative;}
.top-good .good-attr li{ color:#483644;white-space:nowrap; text-overflow:ellipsis; overflow:hidden; width:200px;}
.good-attr .good-sale{ position:absolute; left:-5px; top:0;}
.top-good .good-name{ font-size:16px; margin-left:10px; margin-top:18px;}
.top-good .good-spec{ font-size:14px; margin-left:10px;}
.top-good .good-vender{ margin-left:10px; font-size:14px;}
.special-zone .special-money{ height:47px; margin-top:28px; /*overflow:hidden; */ padding-top:4px;}
.special-money li{ color:#fff; margin-left:20px;}
.special-money .special-sale{ font-size:20px; font-weight:bold; float:left;}
.special-money .special-sale span{ font-size:14px; display:inline-block;}
.special-money .special-normal{ font-size:10px;  text-decoration:line-through; float:left; clear:both;}
.special-money .special-buy{ background-color:#fef200; line-height:27px; padding:0 14px; color:#bd01c8; border-radius:5px; margin-left:20px; margin-top:8px; display:inline-block;}
.addsucc-tips {
	display: block;
    position: absolute;
    top: -73px;
   /*  
    left: 10%; */
    height: 30px;
    line-height: 30px;
    padding: 1px 25px;
    background: #fff;
    box-shadow: 0 0 5px #ddd;
    width:110px;
}
.addsucc-tips i{
	width: 20px;
    height: 26px;
    float: left;
    background: url(//misc.360buyimg.com/user/cart/widget/addtocart-201608/i/addsucc.png) 0 8px no-repeat;
}
.biaoti{
    width:431px;
    margin: 0 auto;
    margin-top: 50px;
    height: 111px;
    text-align: center;
    font-size: 50px;
    line-height: 54px;
}
.coupon{
	width:286px;
	float:left;
	padding-left:10px;
}

.mark {
  /*display: none;*/
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  height: 200px;
  line-height: 200px;
  width: 420px;
  text-align: center;
  font-size: 0.28rem;
  /* color: #fff;
  background: rgba(0, 0, 0, 0.6); */
  color: #292929;
    background: #fff;
  /* background:#000; */
  font-size:26px;
  /*border: 1px solid #1d7ad9;*/
  border-radius: 6px;
}
.mini-dialog-mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    pointer-events: auto;
}
.mini-dialog-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2147483580;
    pointer-events: none;
}
.height50{height:50px; clear: both;}
.vouchers1{width: 1200px; height: 194px; margin:0 auto; clear: both; background: url(/pc/vouchers/v1bg.png) no-repeat;}

.vouchers1 .line1{height: 150px;}
.vouchers1 .line2{height: 40px; text-align: center; line-height: 40px; font-size: 24px; color: #fff;}


.vouchers1 .quanl{width:190px; height: 120px; padding: 20px 50px 10px 100px; float: left;}
.vouchers1 .quanl .text{height: 26px; line-height: 26px; color: #f8b63b; width: 180px; font-size: 18px; background: #fff; letter-spacing: 5px; padding: 0 10px;}
.vouchers1 .quanl .line3{height: 100px;}
.vouchers1 .quanl .line3 .text{ font-size: 14px; line-height: 20px; color: #f8b63b;}
.vouchers1 .quanl .mony{color: #f8b63b; font-size: 80px; font-weight: bold; padding: 10px 0 0 20px; font-family: 黑体；}
.vouchers1 .quanl .mony span{color: #f8b63b; font-size: 28px; float: left; font-weight: normal; margin-top: 56px;}
.vouchers1 .quanr{width:680px; float: right; margin: 0 5px; padding-right: 120px; height: 120px; margin-top: 30px;}
.vouchers1 .quanr .quanr_l{float:left;}
.vouchers1 .quanr .quanr_r{float:right; width: 220px; margin-top: 15px;}
.vouchers1 .quanr .quanr_r .buy{float:right; width: 220px; background: #fbbe4c; border-radius: 30px; height: 60px; line-height: 60px; color: #fff; text-align: center;}
.vouchers1 .quanr .quanr_r .buy:hover{float:right; width: 220px; background: #e69e17; border-radius: 30px; height: 60px; line-height: 60px; color: #fff; text-align: center;}
.vouchers1 .quanr .quanr_r .buy a{color: #fff; text-decoration: none; text-align: center; font-size: 30px;}
.vouchers1 .quanr .text{width:400px; text-align: center; line-height: 60px; font-size: 40px; color: #f8b63b; }
.vouchers1 .quanr .ftitle{width:400px; text-align: center; line-height: 20px; font-size: 18px; color: #f8b63b;}
.vouchers1 .quanr .text a{color: #fff;}


.vouchers2{width: 1200px; height: 480px; margin:20px auto 0 auto; background:url(/pc/vouchers/vbg.png) no-repeat 0; margin-bottom: 50px;}
.vouchers2 .content{ padding: 100px 40px 50px 40px; width: 1120px; height: 330px;}
.vouchers2 .title{font-size: 30px; line-height: 50px; height: 50px; color: #6b4117; margin-left: 10px;}
.vouchers2 .title span.textl{font-size: 40px; line-height: 50px; height: 50px; color: #694219; border-radius: 10px; margin: 0 5px; float: left; font-weight: bold; margin-left: 160px;}
.vouchers2 .title span.textr{font-size: 30px; line-height: 50px; height: 50px; color: #694219; border-radius: 10px; margin: 0 5px; float: right;margin-right: 190px;}
.vouchers2 .title span.textr div,.vouchers2 .title span.textr p,.vouchers2 .title span.textr span{font-size: 30px !important; line-height: 50px; height: 50px; color: #694219;}
.vouchers2 .title span.date{font-size: 30px; line-height: 50px; height: 50px; color: #fff; background: #694219; border-radius: 10px; border-radius: 10px; padding: 0 5px; margin: 0 5px; }
.vochersbg{ width: 540px; height: 250px; background: #fff; border-radius: 10px; float: left; margin: 25px 10px 10px 10px;}
.vochersbg .quan_img{float:left;}
.vochersbg .quan_img{float:left; background:url(/pc/vouchers/quan1bg.png) no-repeat 0; width: 270px; height: 164px;  margin: 40px 0 40px 20px;}
.vouchers2 .buy{font-size: 30px; cursor: pointer; float:right; width: 220px; background: #fbbe4c; border-radius: 30px; height: 60px; line-height: 60px; color: #fff; text-align: center;margin-top: 100px; margin-right: 160px;cursor: pointer;}
.vouchers2 .buy:hover{float:right; width: 220px; background: #e69e17; border-radius: 30px; height: 60px; line-height: 60px; color: #fff; text-align: center;}
.vouchers2 .buy a{color: #fff; text-decoration: none; text-align: center; font-size: 30px; cursor: pointer;}

.vouchers1 img{width: 1200px; height: 194px;margin:20px auto 20px auto;}
.vochersbg .quan_img .quanl{width:255px; height: 115px; float: left;}
.vochersbg .quan_img .quanl .line1{height: 80px;}
.vochersbg .quan_img .quanl .line2{height: 30px; float: left; padding: 0 0 0 30px; clear: both; width: 100%;}
.vochersbg .quan_img .quanl .line2 .text{height: 24px; line-height: 24px; color: #fbc152; width: 140px; font-size: 16px; background: #fff; letter-spacing: 2px; padding: 0 10px; text-align: center;}
.vochersbg .quan_img .quanl .line3{height: 30px; padding: 0 30px; width: 100%;}
.vochersbg .quan_img .quanl .line3 .text{ font-size: 14px; line-height: 20px; color: #fff;}
.vochersbg .quan_img .quanl .mony{width:180px; float: left; color: #fff; font-size: 70px; font-weight: bold; padding: 10px 0 0 30px; border: none; margin-top: 20px; font-family: 黑体;}
.vochersbg .quan_img .quanl .mony span{color: #fff; font-size: 28px; float: left; font-weight: normal; margin-top: 10px;}
.vochersbg .quan_img .quanl .leixing{width:30px; float: right; margin-right: 10px; background: #e94b34; height: 85px;}
.vochersbg .quan_img .quanl .leixing .text{width:28px; float: right; line-height: 25px; font-size: 18px; color: #fff; margin-top: 3px; text-align: center;}




.vochersbg .quan_img img{width: 270px; height: 164px; margin: 40px 0 40px 20px;}
.vochersbg .quan_text{float:left; width: 210px; text-align: left; margin: 20px 20px 40px 20px;}
.vochersbg .quan_text h1{ color: #4c4c4c; font-size: 28px; line-height: 40px; height: 40px; margin-bottom: 10px;}
.vochersbg .quan_text .text{color: #4c4c4c; font-size: 14px; line-height: 20px; }
.vochersbg .quan_text .text h3{color: #4c4c4c; font-size: 14px; line-height: 20px; float: left; width: 65px;height: 40px;}
.vochersbg .quan_text .text span{color: #4c4c4c; width: 140px; font-size: 14px; line-height: 20px; float: right; text-align: left;}

.vochersbg .quan_text .text1{color: #4c4c4c; font-size: 14px; line-height: 20px; margin-top: 10px;}
.vochersbg .quan_text .text1 h3{color: #4c4c4c; font-size: 14px; line-height: 20px; float: left; width: 65px;}
.vochersbg .quan_text .text1 span{color: #4c4c4c; width: 140px; font-size: 14px; line-height: 20px; float: right; text-align: left;}
.vochersbg .mony{ height: 50px; border-bottom: 1px solid #4b4b4b; border-top: 1px solid #4b4b4b; clear: both; line-height: 40px;}
.vochersbg .mony span{color:#e72f2f; line-height: 40px; font-size: 16px;}
.vochersbg .mony span.title{color:#e72f2f; line-height: 40px; font-size: 28px; font-weight: bold;}
.vochersbg .mony span.num{color:#4b4b4b; line-height: 40px; font-size: 16px; font-weight: bold; float: right;}
.vochersbg .buycar{background: #e72f2f; line-height: 35px; font-size: 16px; width: 210px; height: 35px; text-align: center; margin-top: 10px;}
.vochersbg .buycar:hover{background: #c41212; line-height: 35px; font-size: 16px; width: 210px; height: 35px; text-align: center; margin-top: 10px;}
.vochersbg .buycar a{color:#fff; line-height: 35px; font-size: 16px; width: 215px; height: 35px; text-align: center;}


.vouchers3{width: 1200px; height: 480px; margin:20px auto 0 auto; background:url(/pc/vouchers/vbg1.png) no-repeat 0;}
.vouchers3 .content{ padding: 100px 40px 50px 40px; width: 1120px; /*height: 470px;*/ background: none;}
.vouchers3 .title{font-size: 30px; line-height: 50px; height: 50px; color: #c53f3e; margin-left: 10px;}
.vouchers3 .title span.textl{font-size: 36px; line-height: 50px; height: 50px; color: #c53f3e; border-radius: 10px; margin: 0 5px; float: left; font-weight: bold; margin-left: 60px;}
.vouchers3 .title span.textr{font-size: 26px; line-height: 50px; height: 50px; color: #c53f3e; border-radius: 10px; margin: 0 5px; float: right;}
.vouchers3 .title span.date{font-size: 30px; line-height: 50px; height: 50px; color: #fff; background: #c53f3e; border-radius: 10px; border-radius: 10px; padding: 0 5px; margin: 0 5px; }



.vochers_quan{width: 1200px; margin-top: 10px; /*padding: 20px;*/ margin: 0 auto; padding-top: 30px; height: 250px;}
.vochers_quan .quan{width:328px; height: 201px; margin: 22px 22px 22px 22px; float: left; text-align: center; background: url(/pc/vouchers/quanbg.png) no-repeat; }
.vochers_quan .quanl{width:255px; height: 200px; float: left;}
.vochers_quan .quanl .line1{height: 100px;}
.vochers_quan .quanl .line2{height: 30px; float: left; padding: 0 0 0 30px; clear: both;}
.vochers_quan .quanl .line2 .text{height: 26px; line-height: 26px; color: #fbc152; width: 180px; font-size: 18px; background: #fff; letter-spacing: 3px; padding: 0 10px;}
.vochers_quan .quanl .line3{/*height: 100px;*/ clear: both;}
.vochers_quan .quanl .line3 .text{ font-size: 14px; line-height: 20px; color: #fff;}
.vochers_quan .quanl .mony{width:190px; float: left; color: #fff; font-size: 80px; font-weight: bold; padding: 0px 0 0 20px; height: 110px;}

.vochers_quan .quan:nth-child(9) .quanl .mony{width:190px; float: left; color: #fff; font-size: 60px; font-weight: bold; padding: 0px 0 0 20px;  height: 110px;}
.vochers_quan .quanl .mony span{color: #fff; font-size: 28px; float: left; font-weight: normal; margin-top: 10px;}

.vochers_quan .quanl .leixing{width:30px; float: right; margin-right: 10px; background: #e94b34; height: 95px;}
.vochers_quan .quanl .leixing .text{width:30px; float: right; line-height: 25px; font-size: 24px; color: #fff; margin-top: 10px;}

.vochers_quan .quanr{width:60px; float: right; margin: 0 5px;}
.vochers_quan .quanr .text{width:35px; text-align: center; line-height: 30px; font-size: 30px; color: #fff; padding: 35px 10px; vertical-align: middle; height: 130px; display: table-cell; cursor: pointer;}
.vochers_quan .quanr .text a{color: #fff; text-decoration: none !important; cursor: pointer;}



.vochers_quan .none_quan{width:328px; height: 201px; float: left; text-align: center;background: url(/pc/vouchers/none_quan.png) no-repeat; z-index: 665; position: absolute; opacity: 0.8;}
.vochers_quan .none_quan .quan{/*width:328px; height: 201px;  float: left; text-align: center; background: url(noquanbg.png) no-repeat;*/ margin: 0; filter:alpha(opacity=30);-moz-opacity:0.3;opacity:0.30; filter:progid:DXImageTransform.Microsoft.Alpha(opacity=30); -moz-user-select:none;  -webkit-user-select:none; 
 -ms-user-select:none;  -khtml-user-select:none; -o-user-select:none;  user-select:none; }
.vochers_quan .none_quan  .quanr .text{width:40px; text-align: center; line-height: 30px; font-size: 30px; color: #fff; padding: 55px 10px;}


.vochers_quan .none_quan2{width:328px; height: 201px; float: left; text-align: center;background: url(/pc/vouchers/none_quan2.png) no-repeat; z-index: 665; position: absolute; opacity: 0.8;}
.vochers_quan .none_quan2 .quan{/*width:328px; height: 201px;  float: left; text-align: center; background: url(noquanbg.png) no-repeat;*/ margin: 0; filter:alpha(opacity=30);-moz-opacity:0.3;opacity:0.30; filter:progid:DXImageTransform.Microsoft.Alpha(opacity=30); -moz-user-select:none;  -webkit-user-select:none; 
 -ms-user-select:none;  -khtml-user-select:none; -o-user-select:none;  user-select:none; }
.vochers_quan .none_quan2  .quanr .text{width:40px; text-align: center; line-height: 30px; font-size: 30px; color: #fff; padding: 55px 10px;}

.hide_box{z-index:999;filter:alpha(opacity=50);background:#666;opacity: 0.5;-moz-opacity: 0.5;left:0;top:0;height:100%;width:100%;position:fixed;display:none;}
.shang_box{width:380px;height:390px;padding:10px;background-color:#fff;border-radius:10px;position:fixed;z-index:1000;left:50%;top:50%;margin-left:-200px;margin-top:-280px;display:none;}
.shang_box img{border:none;border-width:0;}

.shang_box2{width:380px;height:390px;padding:10px;background-color:#fff;border-radius:10px;position:fixed;z-index:1000;left:50%;top:50%;margin-left:-200px;margin-top:-280px;display:none;}
.shang_box2 img{border:none;border-width:0;}

.shang_close{float:right; display:inline-block;}
.shang_logo{display:block;text-align:center;margin:20px auto;}
.shang_payimg{width:300px; margin:0 auto;border-radius:3px;height:300px; margin-top: 50px;}
.shang_payimg img{display:block;text-align:center;width:300px;height:300px; }
.paybg{width:300px; margin:0 auto;border-radius:3px;height:60px; margin-top: 20px;}
.pay_explain{text-align:center;margin:10px auto;font-size:12px;color:#545454;}
.shang_payselect{text-align:center;margin:0 auto;margin-top:40px;cursor:pointer;height:60px;width:280px;}
.shang_payselect .pay_item{display:inline-block;margin-right:10px; float:left;}
.shang_info{clear:both;}
.shang_info p,.shang_info a{color:#C3C3C3;text-align:center;font-size:12px;text-decoration:none;line-height:2em;}


</style>